import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 1.333c11 0 14.667 7.334 14.667 14.667S27 30.667 16 30.667 1.333 23.333 1.333 16 5 1.333 16 1.333m0 6c-.927 0-1.475 1.373-2.568 4.118l-.244.611-.603.051c-2.835.24-4.252.36-4.54 1.282-.286.922.794 1.89 2.953 3.827l.437.391-.142.623c-.658 2.893-.988 4.34-.237 4.91.75.57 1.965-.204 4.393-1.752l.533-.341.534.34c2.428 1.55 3.643 2.323 4.393 1.753s.421-2.017-.237-4.91l-.136-.595.467-.42c2.159-1.935 3.238-2.903 2.952-3.825s-1.705-1.043-4.54-1.283l-.602-.05-.244-.612C17.475 8.706 16.927 7.333 16 7.333"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarCircleFilledSize32Glyph.displayName = 'StarCircleFilledSize32Glyph';
